import { Box } from '@mui/material';
import { ActionButton } from '../../../components/ActionButton';
import { 
    faReply, faThumbsUp, faThumbsDown, faFlag, faRedo, faPause, faPlay, faTimes 
} from '@fortawesome/free-solid-svg-icons';

interface ActionButtonsGroupProps {
    isApproved: boolean;
    isRejected: boolean;
    isOnHold?: boolean;
    isClosed?: boolean;
    approving: boolean;
    rejecting: boolean;
    reopening?: boolean;
    holding?: boolean;
    resuming?: boolean;
    closing?: boolean;
    onApproveClick: () => void;
    onRejectClick: () => void;
    onReplyClick: () => void;
    onFlagClick: () => void;
    onReOpenClick?: () => void;
    onHoldClick?: () => void;
    onResumeClick?: () => void;
    onCloseClick?: () => void;
}

export function ActionButtonsGroup({ 
    isApproved,
    isRejected,
    isOnHold,
    isClosed,
    approving,
    rejecting,
    reopening,
    holding,
    resuming,
    closing,
    onApproveClick,
    onRejectClick,
    onReplyClick,
    onFlagClick,
    onReOpenClick,
    onHoldClick,
    onResumeClick,
    onCloseClick
}: ActionButtonsGroupProps) {
    return (
        <Box sx={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
            <Box>                <ActionButton
                    icon={faThumbsUp}
                    label="Approve"
                    color="success"
                    sx={{ mr: 1 }}
                    onClick={onApproveClick}
                    disabled={approving || isApproved || isRejected || isOnHold || isClosed}
                />                <ActionButton
                    icon={faThumbsDown}
                    label="Reject"
                    color="error"
                    sx={{ mr: 1 }}
                    onClick={onRejectClick}
                    disabled={rejecting || isApproved || isRejected || isOnHold || isClosed}
                />                {onHoldClick && (
                    <ActionButton
                        icon={faPause}
                        label="Hold"
                        color="info"
                        sx={{ mr: 1 }}
                        onClick={onHoldClick}
                        disabled={holding || isApproved || isRejected || isOnHold || isClosed}
                    />
                )}{isRejected && onReOpenClick && (
                    <ActionButton
                        icon={faRedo}
                        label="Reopen"
                        color="warning"
                        sx={{ mr: 1 }}
                        onClick={onReOpenClick}
                        disabled={reopening}
                    />
                )}                {isOnHold && onResumeClick && (
                    <ActionButton
                        icon={faPlay}
                        label="Resume"
                        color="primary"
                        sx={{ mr: 1 }}
                        onClick={onResumeClick}
                        disabled={resuming}
                    />
                )}
                {onCloseClick && !isClosed && (
                    <ActionButton
                        icon={faTimes}
                        label="Close"
                        color="secondary"
                        sx={{ mr: 1 }}
                        onClick={onCloseClick}
                        disabled={closing || isClosed}
                    />
                )}
            </Box>
            <Box>
                <ActionButton
                    icon={faReply}
                    label="Reply"
                    variant="outlined"
                    sx={{ mr: 1 }}
                    onClick={onReplyClick}
                />
                {/* <ActionButton
                    icon={faFlag}
                    label="Flag"
                    variant="outlined"
                    color="warning"
                    onClick={onFlagClick}
                /> */}
            </Box>
        </Box>
    );
}